import { translateUi } from "@/shared/lib/ui-translate";

export type NeoFolkThemeId =
  | "default"
  | "muertos"
  | "halloween"
  | "venice"
  | "up-helly-aa"
  | "christmas"
  | "hanami"
  | "cyberpunk"
  | "galaxy"
  | "steampunk"
  | "deep-sea"
  | "ancient-egypt"
  | "8bit-retro";

export const NEO_FOLK_THEME_IDS: NeoFolkThemeId[] = [
  "default",
  "muertos",
  "halloween",
  "venice",
  "up-helly-aa",
  "christmas",
  "hanami",
  "cyberpunk",
  "galaxy",
  "steampunk",
  "deep-sea",
  "ancient-egypt",
  "8bit-retro",
];

export const NEO_FOLK_THEME_LABELS: Record<NeoFolkThemeId, string> = {
  get default() { return translateUi("litNeoFolkTheme.standart"); },
  muertos: "Muertos",
  halloween: "Halloween",
  venice: "Venice",
  "up-helly-aa": "Up Helly Aa",
  christmas: "Christmas",
  hanami: "Hanami",
  cyberpunk: "Cyberpunk",
  galaxy: "Galaxy",
  steampunk: "Steampunk",
  "deep-sea": "Deep Sea",
  "ancient-egypt": "Ancient Egypt",
  "8bit-retro": "8-Bit Retro",
};

export function isNeoFolkThemeId(
  v: string | null | undefined,
): v is NeoFolkThemeId {
  return NEO_FOLK_THEME_IDS.includes(v as NeoFolkThemeId);
}
